import VisitorTypeForm from './VisitorTypeForm';

export * from './types';

export default VisitorTypeForm;